/**
 * Avisos de integração (falha/parcial) em formulários de pedido e saída (#MT-989C152).
 */
import api from '../api.js';

const BANNER_STYLE = `
	margin: 0 0 0.75rem 0;
	padding: 0.55rem 0.7rem;
	background: #fff7ed;
	border: 1px solid #fdba74;
	border-radius: 4px;
	color: #9a3412;
	font-size: 0.9em;
	line-height: 1.35;
`;
const TITLE_STYLE = 'font-weight: 600; margin: 0 0 0.35rem 0;';
const LIST_STYLE = 'margin: 0.25rem 0 0 1rem; padding: 0;';
const LINK_STYLE = 'margin-top: 0.35rem; font-size: 0.92em;';

function esc(s)
{
	if (s == null || s === '')
		return '';
	const t = String(s);
	return t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function formatDateTime(iso)
{
	if (!iso)
		return '—';
	try
	{
		const d = new Date(iso);
		if (Number.isNaN(d.getTime()))
			return String(iso);
		return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
	}
	catch (e)
	{
		return String(iso);
	}
}

function centralUrlForEvent(eventId)
{
	const base = '#integration-events';
	if (eventId == null || eventId === '')
		return base;
	return `${base}?open=${encodeURIComponent(eventId)}`;
}

/**
 * @param {object} opts
 * @param {string} opts.formSelector - ex. '#order' ou '#output'
 * @param {string} opts.bannerId - id do elemento banner (sem #)
 * @param {string} opts.companyId
 * @param {string} opts.entityType - ex. 'output_order'
 * @param {string|number} opts.entityId
 * @param {string[]} [opts.integrationKeys]
 */
export async function refreshIntegrationEntityAlerts(opts)
{
	const {
		formSelector,
		bannerId,
		companyId,
		entityType,
		entityId,
		integrationKeys = ['vendatus'],
	} = opts || {};
	const banner = document.querySelector(`${formSelector} #${bannerId}`);
	if (!banner)
		return;
	const hide = () =>
	{
		banner.style.display = 'none';
		banner.innerHTML = '';
	};
	if (!companyId || entityId == null || entityId === '' || !entityType)
	{
		hide();
		return;
	}
	const params = new URLSearchParams({
		company_id: String(companyId),
		entity_type: String(entityType),
		entity_id: String(entityId),
		integration_keys: integrationKeys.join(','),
		days: '30',
		limit: '5',
	});
	try
	{
		const data = await api.call(api.integration_events_entity_alerts, `?${params.toString()}`);
		const alerts = Array.isArray(data?.alerts) ? data.alerts : [];
		if (!alerts.length)
		{
			hide();
			return;
		}
		const items = alerts.map((a) =>
		{
			const detail = a.detail || '';
			const statusPt = a.status === 'partial' ? 'parcial' : 'falha';
			return `<li><strong>${esc(a.integration_label || a.integration_key)}</strong> (${statusPt}, ${formatDateTime(a.date_time)}): ${esc(a.message)}${detail ? `<br><span style="font-weight:normal">${esc(detail)}</span>` : ''} — <a href="${centralUrlForEvent(a.id)}">ver na Central</a></li>`;
		});
		if (!items.length)
		{
			hide();
			return;
		}
		banner.style.cssText = BANNER_STYLE;
		banner.style.display = 'block';
		banner.innerHTML = `
			<p style="${TITLE_STYLE}">Integração — atenção operacional</p>
			<p style="margin:0">O ERP solicitou ação neste registro e o SIAL registrou falha ou resultado parcial nos últimos ${data?.days ?? 30} dias:</p>
			<ul style="${LIST_STYLE}">${items.join('')}</ul>
			<p style="${LINK_STYLE}"><a href="#integration-events">Abrir Central de Integrações</a></p>
		`;
	}
	catch (e)
	{
		hide();
	}
}
